import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { PHONE_LINK } from '../constants';

export default function MobileStickyBar() {
  const handleKontakt = () => {
    const el = document.getElementById('kontakt');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t border-gray-200 shadow-2xl"
    >
      <div className="grid grid-cols-2 h-14">
        <a
          href={PHONE_LINK}
          className="flex items-center justify-center gap-2 bg-[#1B3A5C] text-white font-black text-sm hover:bg-[#0d2540] transition-colors"
        >
          <Phone size={17} /> Anrufen
        </a>
        <button
          onClick={handleKontakt}
          className="flex items-center justify-center gap-2 bg-[#E8722A] text-white font-black text-sm hover:bg-[#d4651e] transition-colors"
        >
          <MessageCircle size={17} /> Anfragen
        </button>
      </div>
    </div>
  );
}
